// AdminGeneralSettings.jsx
import React, { useEffect, useState } from "react";
import { Box, Typography, TextField, Button, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  fetchAccountants,
  saveAccountants,
} from "../../Controllers/accountantController";
import {
  fetchExpensesConfirmers,
  saveExpensesConfirmers,
} from "../../Controllers/expensesConfirmerController";
import { useError } from "../../Context/errorContext";
import { downloadContractFiles } from "../../Controllers/projectController";

const AdminGeneralSettings = () => {
  const [accountants, setAccountants] = useState([]);
  const [newAccountant, setNewAccountant] = useState({ name: "", email: "" });
  const [expensesConfirmers, setExpensesConfirmers] = useState([]);
  const [newExpensesConfirmer, setNewExpensesConfirmer] = useState({
    name: "",
    email: "",
  });
  const { setAlert } = useError();

  useEffect(() => {
    fetchAccountants(setAccountants);
    fetchExpensesConfirmers(setExpensesConfirmers);
  }, []);

  const handleAddAccountant = () => {
    setAccountants([...accountants, newAccountant]);
    setNewAccountant({ name: "", email: "" });
  };

  const handleAddExpensesConfirmer = () => {
    setExpensesConfirmers([...expensesConfirmers, newExpensesConfirmer]);
    setNewExpensesConfirmer({ name: "", email: "" });
  };

  const handleDeleteAccountant = (index) => {
    const updated = [...accountants];
    updated.splice(index, 1);
    setAccountants(updated);
  };

  const handleDeleteExpensesConfirmer = (index) => {
    const updated = [...expensesConfirmers];
    updated.splice(index, 1);
    setExpensesConfirmers(updated);
  };

  const handleSave = async () => {
    saveAccountants(accountants, setAlert);
    saveExpensesConfirmers(expensesConfirmers, setAlert);
  };

  return (
    <Box>
      <Button variant="contained" onClick={downloadContractFiles}>
        Download zip
      </Button>
      <Typography mb={2} variant="h6">
        Accountants
      </Typography>
      {accountants.map((acc, index) => (
        <Box
          key={index}
          display="flex"
          alignItems="center"
          gap={2}
          marginBottom={2}
        >
          <TextField
            value={acc.name}
            onChange={(e) => {
              const updated = [...accountants];
              updated[index].name = e.target.value;
              setAccountants(updated);
            }}
            label="Name"
          />
          <TextField
            value={acc.email}
            onChange={(e) => {
              const updated = [...accountants];
              updated[index].email = e.target.value;
              setAccountants(updated);
            }}
            label="Email"
          />
          <IconButton onClick={() => handleDeleteAccountant(index)}>
            <DeleteIcon />
          </IconButton>
        </Box>
      ))}
      <Box display="flex" gap={2} mt={4}>
        <TextField
          value={newAccountant.name}
          label="New Name"
          onChange={(e) =>
            setNewAccountant({ ...newAccountant, name: e.target.value })
          }
        />
        <TextField
          value={newAccountant.email}
          label="New Email"
          onChange={(e) =>
            setNewAccountant({ ...newAccountant, email: e.target.value })
          }
        />
        <Button variant="contained" onClick={handleAddAccountant}>
          Add
        </Button>
      </Box>

      <Typography mb={2} variant="h6">
        Expenses Confirmers
      </Typography>
      {expensesConfirmers.map((exp, index) => (
        <Box
          key={index}
          display="flex"
          alignItems="center"
          gap={2}
          marginBottom={2}
        >
          <TextField
            value={exp.name}
            onChange={(e) => {
              const updated = [...expensesConfirmers];
              updated[index].name = e.target.value;
              setExpensesConfirmers(updated);
            }}
            label="Name"
          />
          <TextField
            value={exp.email}
            onChange={(e) => {
              const updated = [...expensesConfirmers];
              updated[index].email = e.target.value;
              setExpensesConfirmers(updated);
            }}
            label="Email"
          />
          <IconButton onClick={() => handleDeleteExpensesConfirmer(index)}>
            <DeleteIcon />
          </IconButton>
        </Box>
      ))}
      <Box display="flex" gap={2} mt={4}>
        <TextField
          value={newExpensesConfirmer.name}
          label="New Name"
          onChange={(e) =>
            setNewExpensesConfirmer({
              ...newExpensesConfirmer,
              name: e.target.value,
            })
          }
        />
        <TextField
          value={newExpensesConfirmer.email}
          label="New Email"
          onChange={(e) =>
            setNewExpensesConfirmer({
              ...newExpensesConfirmer,
              email: e.target.value,
            })
          }
        />
        <Button variant="contained" onClick={handleAddExpensesConfirmer}>
          Add
        </Button>
      </Box>

      <Button variant="contained" sx={{ mt: 2 }} onClick={handleSave}>
        Save
      </Button>
    </Box>
  );
};

export default AdminGeneralSettings;
